import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { CreateApiAction } from "../../../api/ApiAction";
import { RootState } from "../../rootState";
import { IGross } from "../types/gross";

export const createGross = createAsyncThunk<void, IGross, { state: RootState }>(
  "services/createGross",
  async (params, thunkAPI) => {
    await endpoints.directory.createGross(
      {
        ...params,
        operator: params.operator_id,
        action: CreateApiAction.createGross,
      },
      thunkAPI.signal,
    );
  },
);
